import React from 'react';
import type { CustomIconComponentProps } from '@ant-design/icons/lib/components/Icon';
const CMP = (props: Partial<CustomIconComponentProps>) => (
  <svg viewBox="0 0 20 20" {...props}>
    <g id="组_468" data-name="组 468" transform="translate(-1570.5 -362.5)" opacity="0.65">
      <path
        id="路径_60"
        data-name="路径 60"
        d="M22.958,25.186a4,4,0,0,1,6.75,0,4,4,0,0,1,4.772,4.773,4,4,0,0,1,0,6.749,4,4,0,0,1-4.772,4.773,4,4,0,0,1-6.75,0,4,4,0,0,1-4.773-4.773,4,4,0,0,1,0-6.749,4,4,0,0,1,4.773-4.773Zm.053,2.129a1,1,0,0,0,1.415-.586,2,2,0,0,1,3.814,0,1,1,0,0,0,1.414.586,2,2,0,0,1,2.7,2.7,1,1,0,0,0,.585,1.414,2,2,0,0,1,0,3.815,1,1,0,0,0-.585,1.414,2,2,0,0,1-2.7,2.7,1,1,0,0,0-1.414.586,2,2,0,0,1-3.814,0,1,1,0,0,0-1.415-.586,2,2,0,0,1-2.7-2.7,1,1,0,0,0-.586-1.414,2,2,0,0,1,0-3.815,1,1,0,0,0,.586-1.414,2,2,0,0,1,2.7-2.7Zm3.322,2.018a4,4,0,1,0,4,4A4,4,0,0,0,26.333,29.333Zm0,2a2,2,0,1,1-2,2A2,2,0,0,1,26.333,31.333Z"
        transform="translate(1554.167 339.167)"
        fill-rule="evenodd"
      />
    </g>
  </svg>
);

export default CMP;
